export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "wordCounter": {
    "title": "Word Counter",
    "subtitle": "Count words, characters, sentences, paragraphs. Analyze keyword density. ",
    "privacy": "100% client-side",
    "noUpload": "no upload needed",
    "inputLabel": "Paste or type your text",
    "placeholder": "Paste your text here to analyze...",
    "words": "Words",
    "wordSingular": "word",
    "wordsPlural": "words",
    "characters": "Characters",
    "noSpaces": "no spaces",
    "sentences": "Sentences",
    "paragraphs": "Paragraphs",
    "readingTime": "Reading Time",
    "avgWord": "Avg Word",
    "longest": "Longest",
    "keywordDensity": "Keyword Density",
    "emptyHint": "Start typing or paste text above to see statistics"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 This tool processes everything locally in your browser. Your data is never uploaded to any server, ensuring complete privacy and security."
    },
    "guide": {
      "title": "How to Use Word Counter",
      "description": "Get instant text statistics for essays, articles, social media posts, and more.",
      "steps": [
        {
          "title": "Paste or type your text",
          "description": "Enter any text into the input area. The tool updates statistics in real time as you type, so there is no need to press any button."
        },
        {
          "title": "Review detailed statistics",
          "description": "View word count, character count (with and without spaces), sentence count, paragraph count, and estimated reading time at a glance."
        },
        {
          "title": "Analyze keyword density",
          "description": "Scroll down to the keyword density section to see which words appear most frequently. This is useful for SEO optimization and content analysis."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Real-time word, character, sentence, and paragraph counting",
        "Estimated reading time based on average adult reading speed",
        "Keyword density analysis for SEO and writing insights",
        "Average word length and longest word detection",
        "Supports English, Chinese, and mixed-language text",
        "Zero data upload — everything stays in your browser"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Does this tool work for Chinese text?",
          "answer": "Yes. The word counter uses Unicode-aware logic that correctly counts Chinese characters, English words, and mixed-language content. Each Chinese character is counted as one word."
        },
        {
          "question": "How is reading time calculated?",
          "answer": "Reading time is estimated based on an average adult reading speed of approximately 200 words per minute for English and comparable rates for other languages. This gives you a quick sense of how long your content takes to read."
        },
        {
          "question": "Is my text stored anywhere?",
          "answer": "No. All analysis happens locally in your browser. As soon as you close the page or refresh, the text is gone. We do not store, log, or transmit any of your content."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Case Converter",
          "url": "/text/case-converter",
          "description": "Convert text between uppercase, lowercase, title case, and more."
        },
        {
          "name": "Lorem Ipsum Generator",
          "url": "/text/lorem-ipsum-generator",
          "description": "Generate placeholder text for your design and layout needs."
        },
        {
          "name": "Markdown Editor",
          "url": "/text/markdown-editor",
          "description": "Write and preview Markdown with a live split-pane editor."
        }
      ]
    }
  }
};
